import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-453625d7"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "download-disabled is-light"
};
const _hoisted_2 = {
  class: "wrapper"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, " 远程遥控电脑下载、取回云盘文件 ", -1));
const _hoisted_5 = {
  class: "desc"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_7 = ["disabled"];
import { store } from '@remote/store';
import { onMounted, computed, ref } from 'vue';
import StaticRemote from '@shared/assets/img/static-remote.png';
// 这张动图比较大，有735KB，所以需要一张静态图先占位，保证展示效果
import DynamicRemote from '@shared/assets/img/remote.png';
import { updateAccessTaskType } from '@remote/api/base';
import { useDeviceStore } from '@remote/store/device';
export default /*#__PURE__*/_defineComponent({
  __name: 'DownloadUnavailable',
  setup(__props) {
    const imgSrc = ref(StaticRemote);
    const isOpening = ref(false);
    onMounted(() => {
      const img = new Image();
      img.src = DynamicRemote;
      img.onload = () => {
        imgSrc.value = DynamicRemote;
      };
    });
    const deviceName = computed(() => {
      const name = store.state.curDeviceRunner.file_name;
      if (name) {
        return `（${name}）`;
      }
      return '';
    });
    const deviceStore = useDeviceStore();
    const open = async () => {
      if (!isOpening.value) {
        isOpening.value = true;
        await updateAccessTaskType(['user#download', 'user#download-url']);
        deviceStore.pollRunnerList(6);
      }
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
        src: imgSrc.value,
        draggable: "false"
      }, null, 8, _hoisted_3), _hoisted_4, _createElementVNode("p", _hoisted_5, [_createTextVNode(" 当前设备" + _toDisplayString(deviceName.value), 1), _hoisted_6, _createTextVNode("未开启远程下载功能 ")]), _createElementVNode("button", {
        class: _normalizeClass({
          'button-base': true,
          'primary-button': true,
          'is-disabled': isOpening.value
        }),
        disabled: isOpening.value,
        onClick: open
      }, _toDisplayString(isOpening.value ? '开启中' : '立即开启'), 11, _hoisted_7)])]);
    };
  }
});